// React
import React from "react";
// Redux
import { connect } from "react-redux";

const Spinner = ({ showing, ...props }) =>
  showing ? (
    <div
      style={{
        alignItems: "center",
        backgroundColor: "rgba(0, 0, 0, 0.3)",
        display: "flex",
        height: "100%",
        justifyContent: "center",
        position: "fixed",
        top: 0,
        width: "100%",
        zIndex: 2000
      }}
    >
      <i className="fa fa-circle-o-notch fa-spin" style={{ fontSize: 72 }} />
    </div>
  ) : null;

const mapStateToProps = (state) => ({
  showing: state.spinner.showing
});

export default connect(mapStateToProps)(Spinner);
